/**
 * toast.js
 * Proxy object for displaying toasts to users (currently using toastr).
 * Example Usage:
 *
 * toast.success()
 *   .title('Foobar')
 *   .message('Quick brown fox')
 *   .send();
 *
 * Only the message and send methods are required to render a toast.
 */
e360.factory('toast', [
   function ()
   {
      // TODO: Sorted -> configure these options with settings
      toastr.options = {
         "closeButton": true,
         "debug": false,
         "extendedTimeOut": "2500",
         "hideDuration": "400",
         "hideEasing": "linear",
         "hideMethod": "slideUp",
         "newestOnTop": false,
         "onclick": null,
         "positionClass": "toast-top-center",
         "preventDuplicates": true,
         "progressBar": true,
         "showDuration": "400",
         "showEasing": "swing",
         "showMethod": "slideDown",
         "timeOut": "3250",
      };

      // toastr.options_dev = {
      //    "closeButton": true,
      //    "debug": true,
      //    "extendedTimeOut": "2500",
      //    "hideDuration": "1500",
      //    "hideEasing": "linear",
      //    "hideMethod": "slideUp",
      //    "newestOnTop": false,
      //    "onclick": null,
      //    "positionClass": "toast-top-center",
      //    "preventDuplicates": false,
      //    "progressBar": true,
      //    "showDuration": "1500",
      //    "showEasing": "swing",
      //    "showMethod": "slideDown",
      //    "timeOut": "3250",
      // };

      return {
         options: {
            type: 'info',
            message: false,
            title: false
         },

         reset: function () {
            this.options.type = 'info';
            this.options.message = false;
            this.options.title = false;

            return this;
         },

         message: function (message) {
            this.options.message = message;
            return this;
         },

         title: function (title) {
            this.options.title = title;
            return this;
         },

         send: function () {
            if (!this.options.message) {
               this.reset();
               return false;
            }

            if (!this.options.title) {
               toastr[this.options.type](this.options.message);
            } else {
               toastr[this.options.type](this.options.message, this.options.title);
            }

            return this.reset();
         },

         success: function () {
            this.options.type = 'success';
            return this;
         },

         warning: function () {
            this.options.type = 'warning';
            return this;
         },

         error: function () {
            this.options.type = 'error';
            return this;
         },

         formErrors: function (err) {
            if (!err.data || !err.data.errors) {
               return this;
            }

            var errors = '';
            _.each(err.data.errors, function (errorGroup) {
               _.each(errorGroup, function (error) {
                  errors += '<div><i class="fa fa-exclamation-triangle"></i> ' + error + '</div>';
               });
            });

            this.message(errors);

            return this;
         }
      };
   }
]);
